import { useRef } from 'react'
import { toaster } from 'components'

/** Hook for copying HTML content as an image to the clipboard */
export function useCopyHtml() {
  const contentRef = useRef<HTMLDivElement>(null)

  const copyToClipboard = async () => {
    if (!contentRef.current) return

    try {
      const html2canvas = await import('html2canvas').then(module => module.default)
      const canvas = await html2canvas(contentRef.current, { backgroundColor: null, scale: 2 })

      const blob = await new Promise<Blob>((resolve, reject) => {
        canvas.toBlob(blob => {
          if (blob) {
            resolve(blob)
          } else {
            reject(new Error('Canvas to Blob conversion failed'))
          }
        }, 'image/png')
      })

      const clipboardItem = new ClipboardItem({ 'image/png': blob })
      await navigator.clipboard.write([clipboardItem])

      toaster.create({
        title: 'Content copied to clipboard',
        type: 'success',
      })
    } catch (error) {
      console.error('Failed to copy content:', error)
      toaster.create({
        title: 'Failed to copy content',
        description: 'Please try again',
        type: 'error',
      })
    }
  }

  return { contentRef, copyToClipboard }
}
